import React, { useEffect, useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { LTICourseCreation as endpoints } from '@URLS'
import { withRouter } from 'react-router-dom'
import { LoadingWave } from '@CommonComponents'

export const LoadingInfo = ({ history }) => {
  const [currentState, dispatch] = useStateValue()
  const [showWave, setShowWave] = useState(true)

  useEffect(() => {
    const startSetupStatus = async () => {
      let resp = await client.get(
        endpoints.checkStatus({
          newCoursenum: currentState.newCoursenum,
        })
      )
      await dispatch({
        type: 'updateSetupStatus',
        payload: {
          isSetUp: resp.data.isSetUp,
          isSettingUp: resp.data.isSettingUp,
        },
      })
      // start the duplication if no one else has started it
      if (!currentState.isSetUp && !currentState.isSettingUp) {
        client.post(endpoints.addCourseObjects(), {
          templateCoursenum: currentState.templateCoursenum,
          newCoursenum: currentState.newCoursenum,
          instrId: currentState.instrId,
        })
      }
    }
    startSetupStatus()
  }, [])

  let requestCount = 0
  let timeOutCount = 45 // request limit before throwing error and clearing the interval; ~1/sec
  // check to see if duplication/setup has finished and send the user on to the endpoint
  useEffect(() => {
    let interval
    const checkSetupStatus = async interval => {
      try {
        let resp = await client.get(
          endpoints.checkStatus({ newCoursenum: currentState.newCoursenum })
        )
        if (!resp.data.isSettingUp && resp.data.isSetUp) {
          await dispatch({
            type: 'updateLoadingDone',
            payload: true,
          })
          history.push(`${currentState.targetUrl}`)
        }
      } catch (err) {
        clearInterval(interval)
        setShowWave(false)
        toast.error(
          `There was an error trying to set up your course. Please contact support@myeducator.com for further assistance.`,
          { autoClose: false }
        )
      }
    }
    interval = setInterval(() => {
      try {
        checkSetupStatus(interval)
        requestCount += 1
        if (requestCount >= timeOutCount) {
          throw new Error(
            'Duplication timeout. The duplication process took too long.'
          )
        }
      } catch (err) {
        clearInterval(interval)
        setShowWave(false)
        toast.error(`There was an error trying to set up your course. Please contact support@myeducator.com for further assistance.`,
          { autoClose: false }
        )
      }
    }, 1 * 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  // loadingspinner is not working so using wave instead. I would prefer the spinner
  return (
    <div className="text-center mt-5">
      {showWave && <LoadingWave position="center" />}
    </div>
  )
}

export default withRouter(LoadingInfo)
